import React from 'react';

import { SVGIcon } from 'UIKit/index';
import Deals from 'Assets/images/AppLogo/deals.svg';

const backgroundStyle = {
    backgroundImage: 'url(' + Deals + ')',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
};
export default function DCDealMenu(props) {
    return <SVGIcon {...props} viewBox="0 0 2000 2000" style={backgroundStyle} />;
}
